import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import { AlunoNivelApp } from '@models/AlunoNivelApp';
import { UnidadeState } from '@models/Unidade';
import React, { useMemo } from 'react';
import "./PermissaoAplicativoAluno.css";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
interface PermissaoAplicativoAlunoProps {
    nivelAppAluno?: AlunoNivelApp
}
const getTexto = (value) => {
    if (typeof value === "boolean") {
        if (value) return <b className="sim">Sim</b>;
        else return <b className="nao">Não</b>;
    }
    if (!value)
        return <b className="nao">Não</b>;
    else return <b className="sim">{value}</b>


}
const PermissaoAplicativoAluno: React.FC<PermissaoAplicativoAlunoProps> = ({ nivelAppAluno }) => {
    const permissoes = useMemo(() => {
        if (!nivelAppAluno) return [];
        return Object.keys(nivelAppAluno).map(x => ({ name: x, value: getTexto(nivelAppAluno[x]) }))
    }, [nivelAppAluno]);

    return <>


        <TableContainer variant="outlined" component={Paper} style={{marginBottom:'20px',paddingBottom:'5px'}}>
            <Table size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        {permissoes.map((row) =>
                            <TableCell style={{ textTransform: 'capitalize' }} key={row.name} component="th" scope="row" >
                                {row.name}
                            </TableCell>
                        )}
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow >
                        {permissoes.map((row) =>
                            <TableCell key={row.name} component="th" scope="row" >
                                {row.value}
                            </TableCell>
                        )}
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    </>;
}

export default PermissaoAplicativoAluno;